import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { validate } from '@adornis/validation/decorators.js';
import { sgNonOptional } from '@martinus/validation/sgNonOptional.js';
import { Person } from '../../../users/entities/person.js';

@Entity()
export class InterviewSlot extends MongoEntity {
  static override _class = 'InterviewSlot';
  static override _collectionName = 'sus-interview-slots';

  constructor(doc: PartialEntityData<InterviewSlot>) {
    super(doc);
  }

  @validate(sgNonOptional())
  @Field(() => ID)
  schoolID: Maybe<string>;

  @validate(sgNonOptional())
  @Field(() => Date)
  startDate: Maybe<Date>;

  @validate(sgNonOptional())
  @Field(() => Date)
  endDate: Maybe<Date>;

  // the id of the student which is assigned to this slot
  @Field(() => ID)
  childID: Maybe<string>;

  // the id of the teacher which interviews the child
  @Field(() => ID)
  interviewerID: Maybe<string>;

  @DataLoadedField(() => Person, ({ interviewerID }) => interviewerID)
  interviewer: Maybe<Person>;
}
